module.exports = __webpack_public_path__ + "static/media/banner2.f3a76853.png";